import React, { useState } from 'react';

// 型定義
interface KeywordIdea {
  text: string;
  avg_monthly_searches: number;
  competition: string;
  yoy_change: number;
  low_bid: number;
  high_bid: number;
}

const Test: React.FC = () => {
  const [project_id] = useState<number>(1);
  const [keywordInput, setKeywordInput] = useState<string>('');
  const [results, setResults] = useState<KeywordIdea[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchKeywordIdeas = async () => {
    if (!keywordInput.trim()) return;

    setLoading(true);
    setError(null);
    const keywords = keywordInput.split(',').map(k => k.trim()).filter(k => k !== "");
    const params = new URLSearchParams();
    params.append('project_id', project_id.toString());
    keywords.forEach(kw => params.append('keywords', kw));

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/get-keyword-planner-ideas?${params.toString()}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'データの取得に失敗しました');
      }

      const data = await response.json();
      setResults(data.keywords);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px', minHeight: '100vh' }}>
      <div style={{ padding: '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
        <h2>キーワードプランナー</h2>

        <div style={{ marginBottom: '20px', display: 'flex', gap: '10px' }}>
          <input
            type="text"
            value={keywordInput}
            onChange={(e) => setKeywordInput(e.target.value)}
            placeholder="キーワードを入力 (例: 新築マンション)"
            style={{ flex: 1, padding: '10px', borderRadius: '4px', border: '1px solid #ccc' }}
          />
          <button
            onClick={fetchKeywordIdeas}
            disabled={loading}
            style={{ padding: '10px 20px', backgroundColor: '#1a73e8', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
          >
            {loading ? '読み込み中...' : '結果を表示'}
          </button>
        </div>

        {error && <div style={{ color: '#d93025', marginBottom: '10px' }}>{error}</div>}

        {results.length > 0 && (
          <div style={{ overflowX: 'auto' }}>
            <p style={{ fontSize: '14px', color: '#666' }}>{results.length} 個のキーワード候補を使用できます</p>
            <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
              <thead>
                <tr style={{ borderBottom: '2px solid #eee', textAlign: 'left', fontSize: '13px', color: '#5f6368' }}>
                  <th style={{ padding: '12px' }}>キーワード</th>
                  <th style={{ padding: '12px' }}>月間平均検索ボリューム</th>
                  <th style={{ padding: '12px' }}>前年比の推移</th>
                  <th style={{ padding: '12px' }}>競合性</th>
                  <th style={{ padding: '12px' }}>上部に掲載（低額）</th>
                  <th style={{ padding: '12px' }}>上部に掲載（高額）</th>
                </tr>
              </thead>
              <tbody style={{ fontSize: '14px' }}>
                {results.map((item, index) => (
                  <tr key={index} style={{ borderBottom: '1px solid #eee' }}>
                    <td style={{ padding: '12px', fontWeight: 'bold' }}>{item.text}</td>
                    <td style={{ padding: '12px' }}>{item.avg_monthly_searches.toLocaleString()}</td>
                    <td style={{ padding: '12px', color: item.yoy_change >= 0 ? '#1e8e3e' : '#d93025' }}>
                      {item.yoy_change > 0 ? `+${item.yoy_change}%` : `${item.yoy_change}%`}
                    </td>
                    <td style={{ padding: '12px' }}>
                      <span style={{
                        padding: '4px 8px',
                        borderRadius: '4px',
                        backgroundColor: item.competition === 'HIGH' ? '#fce8e6' : '#e6f4ea',
                        color: item.competition === 'HIGH' ? '#d93025' : '#1e8e3e',
                        fontSize: '12px'
                      }}>
                        {item.competition === 'HIGH' ? '高' : item.competition === 'MEDIUM' ? '中' : '低'}
                      </span>
                    </td>
                    <td style={{ padding: '12px' }}>¥{Math.floor(item.low_bid).toLocaleString()}</td>
                    <td style={{ padding: '12px' }}>¥{Math.floor(item.high_bid).toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default Test;